function HeadingEmpty() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>A heading contains no content.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>Some users, especially keyboard and screen reader users, often navigate by heading elements. An empty heading will present no information and may introduce confusion.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure that all headings contain informative content.</p>
    </blockquote>
  )
}

export default HeadingEmpty